import React from 'react';
import SEO from '../components/SEO';
import './About.css';

/**
 * About Page Component
 * Explains the purpose and mission of lockitup
 * Describes why the software was created and who it's for
 * Includes SEO meta tags for optimal search engine visibility
 */
function About() {
  return (
    <div className="page-container about-page">
      {/* SEO Meta Tags */}
      <SEO 
        title="About lockitup – Free Laptop Security Software"
        description="Learn about lockitup, a free tool designed to protect your laptop and personal data before repair. Simple, lightweight, and secure."
        keywords="about lockitup, laptop security, free security software, data protection tool"
        ogTitle="About lockitup – Free Laptop Security Software"
        ogDescription="Learn about lockitup, a free tool designed to protect your laptop and personal data before repair."
        ogUrl="https://www.lockitup.tech/about"
      />
      {/* Page Header */}
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            {/* Icon */}
            <div className="page-icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="38" stroke="#27AE60" strokeWidth="3" fill="rgba(39, 174, 96, 0.1)" />
                <path d="M30 40C30 40 35 35 40 35C45 35 50 40 50 40M35 47H35.02M44.98 47H45" stroke="#F1C40F" strokeWidth="3" strokeLinecap="round" />
                <circle cx="40" cy="40" r="18" stroke="#F1C40F" strokeWidth="2.5" />
              </svg>
            </div>
            
            {/* Page Title */}
            <h1 className="page-title">About lockitup</h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="page-content">
        <div className="container">
          <div className="content-wrapper">
            
            {/* Introduction */}
            <div className="content-block">
              <p className="content-text large">
                <strong>lockitup</strong> is a free laptop security tool designed to help users protect their personal data before giving their device for repair.
              </p>
            </div>

            {/* Problem Statement */}
            <div className="content-block">
              <p className="content-text">
                When a laptop is sent to a repair shop, personal files, photos, documents, and accounts may be exposed. lockitup solves this problem by allowing users to lock their laptop with a secure fullscreen lock and password protection.
              </p>
            </div>

            {/* Mission Statement */}
            <div className="mission-box">
              <h2 className="mission-title">Our Mission is Simple:</h2>
              <p className="mission-text">
                Give everyone an easy and free way to protect their privacy.
              </p>
            </div>

            {/* Target Audience */}
            <div className="content-block">
              <p className="content-text">
                lockitup is lightweight, easy to use, and does not require internet access to function. It is built for students, professionals, and everyday users who value their data privacy.
              </p>
            </div>

            {/* Features Grid */}
            <div className="about-features">
              <div className="about-feature-card">
                <div className="about-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 5C20 5 12 12 12 18C12 21.866 15.134 25 20 25C24.866 25 28 21.866 28 18C28 12 20 5 20 5Z" stroke="#27AE60" strokeWidth="2.5" fill="rgba(39, 174, 96, 0.1)" />
                  </svg>
                </div>
                <h3>Lightweight</h3>
                <p>Minimal resource usage, won't slow down your system</p>
              </div>

              <div className="about-feature-card">
                <div className="about-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 20L18 28L32 14" stroke="#27AE60" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h3>Easy to Use</h3>
                <p>Simple interface, no technical knowledge required</p>
              </div>

              <div className="about-feature-card">
                <div className="about-feature-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="8" y="15" width="24" height="18" rx="2" stroke="#27AE60" strokeWidth="2.5" fill="rgba(39, 174, 96, 0.1)" />
                    <path d="M12 15V11C12 7.68629 14.6863 5 18 5H22C25.3137 5 28 7.68629 28 11V15" stroke="#27AE60" strokeWidth="2.5" strokeLinecap="round" />
                    <circle cx="20" cy="24" r="2" fill="#F1C40F" />
                  </svg>
                </div>
                <h3>Offline</h3>
                <p>No internet connection needed to protect your data</p>
              </div>
            </div>

            {/* Tagline */}
            <div className="tagline-section">
              <h2 className="tagline-highlight">Completely Free. Fully Secure.</h2>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
